<h1 [ngClass]="{'black-text': isTextBlack}">{{text}}</h1>